/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import AVTAR from '../../../../assets/scss/Avtar/Ellipse 2.png';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import AddIcon from '@material-ui/icons/Add';

import {
  AppBar,
  Button,
  IconButton,
  Toolbar,
  Hidden,
  colors,
  Typography,
  Grid,
  Menu,
  MenuItem,
  Avatar,
  Dialog,
  Tooltip,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import InputIcon from '@material-ui/icons/Input';
import AsyncLocalStorage from '@createnextapp/async-local-storage';
import MenuIcon from '@material-ui/icons/Menu';
import Balance from '../../../../assets/scss/BalanceIcon.svg';
import useRouter from 'utils/useRouter';
import Logo from '../../../../assets/scss/logo/Logo.svg';
import SignoutPopup from 'views/SignoutPopup';
import Api from '../../../../Helper/ApiHandler';
import AppDataContext from 'Helper/AppDataContext';
import { useHistory } from 'react-router';
import { DialogTitle } from '@mui/material';
import AddWallet from 'views/AddWallet';
var api = new Api();

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    background: '#FF2D47'
  },
  flexGrow: {
    flexGrow: 1
  },
  buttonText: {
    [theme.breakpoints.down('xs')]: {
      display: 'none' // Hide text on mobile
    }
  },
  buttonIcon: {
    paddingRight: 3,
    marginRight: 2,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0, // Remove extra padding on mobile
      marginRight: 0
    }
  },
  walletAmount2: {
    fontFamily: 'Poppins',
    marginTop: '10px',
    fontSize: 15,
    fontWeight: 600,
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },
  grid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  form__input: {
    width: '100%',
    height: '45px',
    border: '0.5px solid #E1E1E1',
    borderRadius: '8px',
    fontSize: 14,
    color: '#FF2D47',
    fontFamily: 'Poppins',
    marginTop: '5px',
    padding: 10,
    resize: 'none'
  },
  qrCodeImage: {
    width: '100%',
    height: 'auto'
  },
  qrCodeContainer: {
    marginTop: '12px',
    border: '1px solid #eeeeee',
    padding: '5px',
    borderRadius: '10px'
  },
  qrContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  search: {
    backgroundColor: 'rgba(255,255,255, 0.1)',
    borderRadius: 4,
    flexBasis: 300,
    height: 36,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  font7: {
    fontFamily: 'Poppins',
    fontSize: 16,
    fontWeight: 500,
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: 'inherit'
  },
  profile: {
    color: '#ffffff'
  },
  menufont__loop: {
    color: '#ffffff'
  },
  searchInput: {
    flexGrow: 1,
    color: 'inherit',
    '& input::placeholder': {
      opacity: 1,
      color: 'inherit'
    }
  },
  avatar: {
    margin: '0px 10px',
    border: 'solid 3px white'
  },
  searchPopper: {
    zIndex: theme.zIndex.appBar + 100
  },
  searchPopperContent: {
    marginTop: theme.spacing(1)
  },
  trialButton: {
    marginLeft: theme.spacing(2),
    color: theme.palette.white,
    backgroundColor: colors.green[600],
    '&:hover': {
      backgroundColor: colors.green[900]
    }
  },
  trialIcon: {
    marginRight: theme.spacing(1)
  },
  notificationsButton: {
    marginLeft: theme.spacing(1)
  },
  notificationsBadge: {
    backgroundColor: colors.orange[600]
  },
  font: {
    color: 'white',
    marginRight: '10px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      // Adjust styles for mobile
      fontSize: '1rem' // Example: adjust font size for mobile
    }
  },
  balanceText: {
    cursor: 'pointer',
    [theme.breakpoints.down('xs')]: {
      display: 'none' // Hide "Current Balance" text on mobile
    }
  },
  logoutButton: {
    marginLeft: theme.spacing(0),
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 400,
    [theme.breakpoints.down('xs')]: {
      minWidth: 'auto', // Prevent button from being too wide on mobile
      padding: theme.spacing(1) // Adjust padding for icon-only button
    }
    // fontSize:14
  },
  icon: {
    marginRight: theme.spacing(1), // Space between icon and text
    [theme.breakpoints.down('xs')]: {
      marginRight: theme.spacing(0.5) // Smaller margin on mobile
    }
  },
  redText: {
    color: 'red'
  },
  dialogUpper: {
    backgroundColor: '#FF2D47',
    color: 'white',
    // boxShadow:
    //   '-2px -4px 7px 0px rgb(0 0 0 / 0%), 0px 6px 10px 4px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)',
    marginBottom: '20px'
  },
  modal_heading: {
    fontSize: 18,
    color: 'white',
    fontWeight: 500
  },
  closeButton: {
    color: 'white'
  },
  input_label1: {
    fontSize: '16px',
    fontWeight: 400,
    color: '#000',
    fontFamily: 'Poppins'
  },
  logoutIcon: {
    marginRight: theme.spacing(1)
  },
  expiryChip: {
    display: 'flex',
    alignItems: 'center',
    gap: '7px',
    backgroundColor: 'rgba(255,255,255,0.15)',
    border: '1px solid rgba(255,255,255,0.35)',
    borderRadius: '8px',
    padding: '5px 12px',
    marginRight: theme.spacing(1.5),
    cursor: 'pointer',
    transition: 'background 0.2s',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.25)'
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  expiryChipUrgent: {
    backgroundColor: 'rgba(255,220,0,0.18)',
    border: '1px solid rgba(255,220,0,0.6)',
    '&:hover': {
      backgroundColor: 'rgba(255,220,0,0.28)'
    }
  },
  expiryChipExpired: {
    backgroundColor: 'rgba(0,0,0,0.2)',
    border: '1px solid rgba(255,255,255,0.25)'
  },
  expiryChipTrial: {
    backgroundColor: 'rgba(76, 175, 80, 0.25)',
    border: '1px solid rgba(76, 175, 80, 0.7)',
    '&:hover': {
      backgroundColor: 'rgba(76, 175, 80, 0.38)'
    }
  },
  expiryDot: {
    width: 7,
    height: 7,
    borderRadius: '50%',
    flexShrink: 0
  },
  expiryPlanName: {
    color: 'white',
    fontSize: '12px',
    fontFamily: 'Poppins',
    fontWeight: 600,
    lineHeight: 1.25,
    whiteSpace: 'nowrap'
  },
  expiryText: {
    color: 'rgba(255,255,255,0.85)',
    fontSize: '11px',
    fontFamily: 'Poppins',
    fontWeight: 400,
    lineHeight: 1.25,
    whiteSpace: 'nowrap'
  },
  expirySubText: {
    color: 'rgba(255,255,255,0.65)',
    fontSize: '9px',
    fontFamily: 'Poppins',
    fontWeight: 400,
    lineHeight: 1.2
  }
}));

const TopBar = props => {
  const { onOpenNavBarMobile, className, ...rest } = props;
  const { appContext, setAppContext } = useContext(AppDataContext);
  const [user, setUser] = useState('');
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  const [userName, setUserName] = useState('');
  const [showQRCode, setShowQRCode] = useState(false);
  const [sessionExpired, setSessionExpired] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [bussinesswallet, setBussinesswallet] = useState();
  const [data, setData] = useState([]);
  const [balance, setBalance] = useState('');
  const [qrcodeLoader, setQrcodeLoader] = useState(false);
  const [expiryDate, setExpiryDate] = useState(null);
  const [currentPlanName, setCurrentPlanName] = useState(null);
  const [isTrial, setIsTrial] = useState(false);

  const classes = useStyles();
  const router = useRouter();
  const [loginOpen, setLoginOpen] = useState();
  const history = useHistory();
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    allData();
    currentBalance();
    fetchExpiryInfo();
  }, []);

  const businessWallet = parseInt(localStorage.getItem('wallet'));

  const allData = async () => {
    try {
      let payload = await api.get('business/getBusiness');
      if (payload.success === true) {
        setData(payload.data);
        let u_id = await AsyncLocalStorage.getItem('businessid');
        let u_name = await AsyncLocalStorage.getItem('businessName');
        // let total_balance = await AsyncLocalStorage.getItem('total_balance');
        // setUser(u_id);
        // setUserName(u_name);
        if (u_id) {
          setUser(u_id);
          setUserName(u_name);
        } else {
          if (payload?.data?.length) {
            setUser(payload.data[0].id);
            setUserName(payload.data[0].business_name);
            localStorage.setItem(
              'business_master_id',
              payload?.data[0].business_master_id
            );
            AsyncLocalStorage.setItem('businessid', payload.data[0].id);
            setAppContext({ ...appContext, business: payload.data[0].id });
            AsyncLocalStorage.setItem(
              'businessName',
              payload.data[0].business_name
            );
            AsyncLocalStorage.setItem(
              'businessEmail',
              payload.data[0].business_email
            );
            // AsyncLocalStorage.setItem(
            //   'wallet',
            //   payload.data[0].wallet
            // );

            // window.location.reload();
          }
        }
      }
    } catch (error) {
      console.error(error.message);
    }
  };
  // const handleLogout = async () => {
  //   try {
  //     let payload = await api.get('logOut')
  //     if (payload.success === true) {
  //       localStorage.clear();
  //       router.history.push("/")
  //     } else {
  //     }
  //   } catch (error) {
  //   }
  // };

  const [message, setMessage] = useState(false);
  // const handleLogout = e => {
  //   // e.preventDefault();
  //   setLoginOpen(true);
  //   // // e.preventdefault()
  //   // api
  //   //   .get('logOut')
  //   //   .then(result => {
  //   //     if (result.success === true) {
  //   //       localStorage.clear();
  //   //       router.history.push('/');
  //   //     } else {
  //   //     }
  //   //   })
  //   //   .catch(err => {
  //   //   });
  // };
  const handleOpenDialog = () => {
    setMessage(true); // Set message to true to show the dialog
  };

  const handleGetStarted2 = () => {
    setOpen(true);
    setSessionExpired(false);
  };

  const currentBalance = async () => {
    let businessid =
      (await AsyncLocalStorage.getItem('businessid')) || appContext.business;
    api
      .get(`business/business_balance/${businessid}`)
      .then(result => {
        AsyncLocalStorage.setItem('wallet', result?.wallet);
        setBussinesswallet(result?.wallet);
      })
      .catch(err => {
        console.error(err, 'error catch');
      });
  };

  const fetchExpiryInfo = async () => {
    try {
      let businessid =
        (await AsyncLocalStorage.getItem('businessid')) ||
        localStorage.getItem('businessid') ||
        appContext.business;
      const result = await api.get(
        `allSubsPlans?service_type=gym_management&business_id=${businessid}`
      );
      if (result?.business_expiries) {
        setExpiryDate(result.business_expiries);
      }
      if (result?.is_trial !== undefined) {
        setIsTrial(!!result.is_trial);
      }
      if (result?.plan_name) {
        setCurrentPlanName(result.is_trial ? 'Free Trial' : result.plan_name);
      } else if (result?.data && result.data.length > 0) {
        // Fallback: find the active/most_popular plan from the list
        const activePlan = result.data.find(p => p.most_popular) || result.data[0];
        setIsTrial(!!activePlan?.is_trial);
        setCurrentPlanName(activePlan?.is_trial ? 'Free Trial' : (activePlan?.plan_name || null));
      }
    } catch (err) {
      console.error('expiry fetch error', err);
    }
  };

  // Returns { daysLeft, isExpired, isUrgent(<=7 days) }
  const getExpiryStatus = () => {
    if (!expiryDate) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const expiry = new Date(expiryDate);
    expiry.setHours(0, 0, 0, 0);
    const diffMs = expiry - today;
    const daysLeft = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return {
      daysLeft,
      isExpired: daysLeft < 0,
      isUrgent: daysLeft >= 0 && daysLeft <= 7
    };
  };
  const isMobile = useMediaQuery(theme.breakpoints.down('xs')); // Mobile breakpoint (≤600px)
  const expiryStatus = getExpiryStatus();
  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
    // color="primary"
    >
      <Toolbar>
        <RouterLink to="/fittlab/Dashboard">
          <img alt="Fitt Lab Studio Logo" src="/images/fitt_lab_studio.png" style={{ height: '60px', width: 'auto', objectFit: 'contain', margin: '5px 0' }} />
        </RouterLink>
        <div className={classes.flexGrow} />

        {/* Subscription expiry chip */}
        {expiryStatus && (
          <Tooltip
            title={
              isTrial
                ? 'You are on a Free Trial. Upgrade to a paid plan.'
                : expiryStatus.isExpired
                ? 'Your subscription has expired. Please renew.'
                : `Subscription expires on ${expiryDate}`
            }>
            <div
              className={`${classes.expiryChip} ${
                isTrial
                  ? ''
                  : expiryStatus.isExpired
                  ? classes.expiryChipExpired
                  : expiryStatus.isUrgent
                  ? classes.expiryChipUrgent
                  : ''
              }`}
              onClick={() => history.push('/Subscription')}>
              {/* Pulsing dot */}
              <span
                className={classes.expiryDot}
                style={{
                  backgroundColor: isTrial
                    ? '#4cef88'
                    : expiryStatus.isExpired
                    ? '#bbb'
                    : expiryStatus.isUrgent
                    ? '#FFD700'
                    : '#4cef88'
                }}
              />
              <div>
                {currentPlanName && (
                  <div className={classes.expiryPlanName}>{currentPlanName}</div>
                )}
                {isTrial ? (
                  <div className={classes.expiryText}>Expires in ({expiryStatus.daysLeft === 0 ? 'Today' : `${expiryStatus.daysLeft} days`})</div>
                ) : expiryStatus.isExpired ? (
                  <div className={classes.expiryText}>Plan Expired · Renew now</div>
                ) : (
                  <div className={classes.expiryText}>
                    {expiryStatus.daysLeft === 0
                      ? 'Expires Today!'
                      : `Expires in (${expiryStatus.daysLeft} days)`}
                  </div>
                )}
              </div>
            </div>
          </Tooltip>
        )}

        {/* <Hidden xsDown> */}
        <Grid className={classes.grid}>
          <Typography className={classes.font}>
            <img alt="Cookies" src={Balance} className={classes.icon} />
            {!isMobile && (
              <span
                className={classes.balanceText}
                onClick={() => history.push('/fittlab/Transactions/overview')}
              >
                Current Balance : <strong> ₹ {bussinesswallet || 0}</strong>
              </span>
            )}

          </Typography>
          {/* <div className={classes.profile}>
              <Button
                fullWidth
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleClick}
                className={classes.font}>
                <strong>{userName ? userName : ''}</strong>
                <Avatar alt="Person" className={classes.avatar} src={AVTAR} />
                <KeyboardArrowDownIcon />
              </Button>
              <Menu
                className={classes.menubtn}
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}>
                {data.map((obj, ind) => {
                  return (
                    <>
                      <MenuItem
                        // className={classes.menufont__loop}
                        key={`obj_${ind}`}
                        onClick={() => {
                          handleClose();
                          setUser(obj?.id);
                          setUserName(obj?.business_name);
                          AsyncLocalStorage.setItem('businessid', obj.id);
                          AsyncLocalStorage.setItem(
                            'businessName',
                            obj.business_name
                          );
                          setAppContext({ ...appContext, business: obj.id });
                          history.push('/staffmanagement/staff');
                          // window.location.reload();
                        }}
                        value={obj?.id}>
                        {obj?.business_name}
                      </MenuItem>
                    </>
                  );
                })}
                <MenuItem
                  className={classes.menufont}
                  // onClick={() => { handleAdd() }}
                  onClick={() => {
                    history.push(`/auth/details`);
                  }}>
                  Add Business
                </MenuItem>
                <MenuItem>Sign Out</MenuItem>
              </Menu>
            </div> */}
        </Grid>
        <Grid className={classes.grid}>
          <Tooltip title="Add Wallet">
            <Button
              className={classes.logoutButton}
              color="inherit"
              onClick={handleGetStarted2}>
              <AddIcon className={classes.buttonIcon} />
              <span className={classes.buttonText}>Add Wallet</span>
            </Button>
          </Tooltip>
        </Grid>
        {/* <IconButton sx={{ color: 'white' }}>
            <AddIcon />
          </IconButton> */}
        <SignoutPopup
          open={loginOpen}
        // setLoginOpen={setLoginOpen}`
        // onOverTimeUpdate={onOverTimeUpdate}
        // minWithdraw={minWithdraw}
        />
        {/* </Hidden> */}
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onOpenNavBarMobile}>
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
      <AddWallet
        open={open}
        setOpen={setOpen}
        currentBalance={currentBalance}
        setSessionExpired={setSessionExpired}
        sessionExpired={sessionExpired}
      />
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func
};

export default TopBar;
